module.exports = __webpack_public_path__ + "static/media/sura-headset.242298d5.svg";